import $ from "jquery"
import "slick-carousel-latest"

// Testimonials counter
let $slickElement = $('.js-slider-testimonials');
let $status = $('.js-testimonials-counter');
$slickElement.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
    let i = (currentSlide ? currentSlide : 0) + 1;
    $status.text(i + '/' + slick.slideCount);
});

// Testimonials new counter
let $slickElementNew = $('.js-slider-testimonials-new');
let $statusNew = $('.js-testimonials-counter-new');
$slickElementNew.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
    let i = (currentSlide ? currentSlide : 0) + 1;
    $statusNew.text(i + '/' + slick.slideCount);
});
$slickElementNew.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 15000,
    prevArrow: $('.testimonials-prev'),
    nextArrow: $('.testimonials-next'),
});

// blog slider
$('.people-slider').slick({
    infinite: true,
    slidesToShow:4,
    slidesToScroll: 1,
    arrow: true,
    nextArrow:"<span class='slick-arrow slick-next d-flex justify-content-center align-items-center '><i class='fa-solid fa-arrow-right'></i></span>",
    prevArrow:"<span class='slick-arrow slick-prev d-flex justify-content-center align-items-center '><i class='fa-solid fa-arrow-left'></i></span>",
    responsive: [
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 3
          }
        },
        {
            breakpoint: 936,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 625,
            settings: {
                slidesToShow: 1
            }
        }
    ]
});

// section statement page outsourcing
$('.section--statement__wrapper').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrow: false,
    dots: false,
    fade: true,
});
